import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Container } from 'reactstrap';
import { injectIntl } from 'react-intl';

import {
  APIgetGroups,
  APIdeleteGroup,
} from '../../api/Group';

import { showConfirmationModal } from '../../actions/App';

import AdminGroupsHeader from '../../components/Admin/Groups/Header';
import AdminGroupsList from '../../components/Admin/Groups/List';
import AdminGroupsFooter from '../../components/Admin/Groups/Footer';

import { getVisibleItemsText } from '../../helpers';
import { getUserSetting } from '../../helpers/Settings';
import { handleComponentParams, handleURLParams } from '../../helpers/URLParams';

import Loading from '../../components/Loading';
import ErrorBoundary from '../../components/ErrorBoundary';
import HelpIcon from '../../components/HelpIcon';
import TrialNotice from '../../components/TrialNotice';
import EmptyCustomTeams from '../EmptyContainers/CustomTeams';

class AdminGroups extends Component {
  constructor(props) {
    super(props);

    this.state = {
      groups: [],
      groupsTotal: 0,
      page: 1,
      perPage: getUserSetting('admin_per_page') || 20,
      orderBy: 'name',
      order: 'asc',
      loading: true,
    };

    this.handleChangeOrder = this.handleChangeOrder.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangePerPage = this.handleChangePerPage.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.loadGroups = this.loadGroups.bind(this);
  }

  componentDidMount() {
    const { history, location } = this.props;
    const { orderBy, order } = this.state;
    const queryParams = new URLSearchParams(location.search);

    handleComponentParams(
      true,
      ['page', 'perPage', 'orderBy', 'order'],
      null,
      this.setState.bind(this),
      () => this.loadGroups(),
      { orderBy: 'name', order: 'asc', perPage: getUserSetting('admin_per_page') || 20 },
    );

    if (!queryParams.get('orderBy')) {
      handleURLParams({ orderBy }, history);
    }

    if (!queryParams.get('order')) {
      handleURLParams({ order }, history);
    }
  }

  componentDidUpdate(prevProps) {
    handleComponentParams(
      false,
      ['page', 'perPage', 'orderBy', 'order'],
      prevProps,
      this.setState.bind(this),
      () => this.loadGroups(),
      { orderBy: 'name', order: 'asc', perPage: getUserSetting('admin_per_page') || 20 },
    );
  }

  loadGroups() {
    const {
      page,
      perPage,
      orderBy,
      order,
    } = this.state;

    this.setState({ loading: true });

    APIgetGroups({
      page,
      per_page: perPage,
      order_by: orderBy,
      order,
    }).then((response) => {
      const { data } = response;
      if (data) {
        this.setState({
          loading: false,
          groups: data.data,
          groupsTotal: data.meta.total,
        });
      }
    });
  }

  handleChangeOrder(orderBy, order) {
    const { history } = this.props;
    handleURLParams({ orderBy, order, page: 1 }, history);

    this.setState({
      orderBy,
      order,
      page: 1,
    });
  }

  handleChangePage(page) {
    const { history } = this.props;
    handleURLParams({ page }, history);

    this.setState({
      page,
    });
  }

  handleChangePerPage(perPage) {
    const { history } = this.props;
    handleURLParams({ perPage, page: 1 }, history);

    this.setState({ perPage, page: 1 });
  }

  handleDelete(group) {
    const { deleteGroup } = this.props;

    deleteGroup(group, this.loadGroups);
  }

  render() {
    const {
      intl,
    } = this.props;
    const {
      page,
      perPage,
      groupsTotal,
      loading,
    } = this.state;

    return (
      <div className="settings-inner-content">
        <div className="main-content teams-content">
          <Container fluid>
            <AdminGroupsHeader
              groupsTotal={groupsTotal}
              groupsVisible={getVisibleItemsText(page, perPage, groupsTotal)}
              loading={loading}
            />
            <TrialNotice feature="custom-teams" className="pl-0" />
            <p>
              {intl.formatMessage({ defaultMessage: 'Create groups of your workspace users so you can invite them to collaborate on Collections and files quickly and easily.' })}
              <HelpIcon
                id="help-teams"
                url="https://help.stockpress.co/en/articles/5937385-create-teams-in-your-workspace"
              />
            </p>
            {loading ? (
              <Loading />
            ) : (
              <>
                {groupsTotal > 0 ? (
                  <>
                    <ErrorBoundary>
                      <AdminGroupsList
                        {...this.state}
                        handleChangeOrder={this.handleChangeOrder}
                        handleDelete={this.handleDelete}
                      />
                    </ErrorBoundary>
                    <ErrorBoundary>
                      <AdminGroupsFooter
                        {...this.state}
                        handleChangePage={this.handleChangePage}
                        handleChangePerPage={this.handleChangePerPage}
                      />
                    </ErrorBoundary>
                  </>
                ) : (
                  <EmptyCustomTeams link="/admin/settings/teams/add" />
                )}
              </>
            )}
          </Container>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch, props) => ({
  deleteGroup: (group, loadGroups) => {
    const { intl } = props;
    const modalParams = {
      title: intl.formatMessage({ defaultMessage: 'Are you sure?' }),
      text: intl.formatMessage({ defaultMessage: 'Are you sure you want to delete this Team? This action can not be undone.' }),
      onConfirm: () => (
        APIdeleteGroup(group.uuid).then(() => {
          loadGroups();
        })
      ),
    };
    dispatch(showConfirmationModal(modalParams));
  },
});

AdminGroups.propTypes = {
  intl: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  deleteGroup: PropTypes.func.isRequired,
};

export default withRouter(injectIntl(connect(null, mapDispatchToProps)(AdminGroups)));
